/* unplugin-vue-components disabled */import script from "./global-data.vue?vue&type=script&lang=js"
export * from "./global-data.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__